import type { AiAgentPaymentRequestSuggestBody } from '../../openapi/model/aiAgentPaymentRequestSuggestBody';

const isAiAgentPaymentRequestSuggestBody = (
  body: unknown
): body is AiAgentPaymentRequestSuggestBody => {
  if (typeof body !== 'object' || body === null) {
    return false;
  }

  return ['files'].every((key) => key in body);
};

export const customFomDataFn = <Body>(body: Body): FormData => {
  const formData = new FormData();
  if (isAiAgentPaymentRequestSuggestBody(body) && body.files) {
    body.files.forEach((file, idx) => {
      if (file.data) {
        formData.append(`files[${idx}][data]`, file.data);
      }
      formData.append(
        `files[${idx}][filename]`,
        file.filename || 'invoice.pdf'
      );
    });
  }
  return formData;
};
